import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {

  transform(value: number): string {
    value = +value;
    const hasNotValidValue = (!value && value === 0) || isNaN(value);
    if (hasNotValidValue) {
      return 'NA';
    }

    // Convert the input value from ss to hours, minutes, or ss
    if (value < 60) {
      return `${value.toFixed(2)}s`;
    } else if (value < 3600) {
      const minutes = +Math.floor(value / 60).toFixed(2);
      const ss = +(value % 60).toFixed(2);
      return `${minutes}min ${ss}s`;
    } else {
      const hours = +Math.floor(value / 3600).toFixed(2);
      const minutes = +Math.floor((value % 3600) / 60).toFixed(2);
      return `${hours} hour${hours !== 1 ? 's' : ''}` + (minutes > 0 ? `, ${minutes} minute${minutes !== 1 ? 's' : ''}` : '');
    }
  }
}
